import useTranslation from "@/hook/useTranslation";
import React from "react";
import { BsGraphUpArrow } from "react-icons/bs";
import { FiPercent } from "react-icons/fi";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import { LuCalendarClock } from "react-icons/lu";
import { LuBrain } from "react-icons/lu";
import { LuBadgeDollarSign } from "react-icons/lu";
import { LuBookmarkPlus } from "react-icons/lu";
import { HiOutlineArrowRight } from "react-icons/hi";
import { useRouter } from "next/navigation";

export default function FinancialToolstLayout() {
  const { t, locale } = useTranslation();
  const router = useRouter();
  const highlights = [
    {
      icon: <FiPercent size={32} className="text-[#26c48c]" />,
      title: t("FinancialToolsContentTitle1"),
      desc: t("FinancialToolsContentDescription1"),
      path: `/${locale}/tools/calendar`,
    },
    {
      icon: <HiOutlineClipboardCheck size={32} className="text-[#26c48c]" />,
      title: t("FinancialToolsContentTitle2"),
      desc: t("FinancialToolsContentDescription2"),
      path: `/${locale}/tools/currency-converter`,
    },
    {
      icon: <LuCalendarClock size={32} className="text-[#26c48c]" />,
      title: t("FinancialToolsContentTitle3"),
      desc: t("FinancialToolsContentDescription3"),
      path: `/${locale}/tools/regulatory-enquiries`,
    },
    {
      icon: <LuBrain size={32} className="text-[#26c48c]" />,
      title: t("FinancialToolsContentTitle4"),
      desc: t("FinancialToolsContentDescription4"),
      path: `/${locale}/tools/mbti-test`,
    },
  ];

  return (
    <div className="fianancial-tools-layout">
      <div className="content">
        <h2 className="text-title">
          <BsGraphUpArrow style={{ marginRight: 8 }} color={"#26c48c"} />
          {t("FinancialTools")}
        </h2>
        <h1 className="key-highlight-title"> {t("Financialtoolstitle")}</h1>
        {/*TODO:Create card 3 card in one line */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {highlights.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 text-center shadow-md text-gray-800 hover:scale-[1.05] transition-transform card"
            >
              <div className="mb-4 flex justify-center">
                <div className="icon-wrapper">
                  <div className="icon-background">{item.icon}</div>
                </div>
              </div>
              <div className="title-card">{item.title}</div>
              <p className="text-sm text-gray-600 description">{item.desc}</p>
              <button
                className="tools-button flex items-center px-5 py-2 border border-gray-300 rounded-full bg-white text-black hover:bg-gray-100 transition cursor-pointer"
                onClick={() => {
                  if (item.path.startsWith("https://")) {
                    window.open(item.path, "_blank");
                  } else {
                    window.location.href = item.path;
                  }
                }}
              >
                <HiOutlineArrowRight className="mr-2 text-lg" />
                <span className="font-medium">Explore</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
